import React from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import HeroSection from "../../components/Landing Part/HeroSection";

const HomePage = () => {
  return (
    <>
      <Header />
      <HeroSection />
      <Footer />
    </>
  );
};

export default HomePage;
